module.exports = __webpack_public_path__ + "70847702ef1433398e0ac9dd8b88b2fa.webm";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/spacemarines-preview.webm
// module id = 648
// module chunks = 0